// routes.js
import Login from '../pages/auth/Login';

import WarehouseDashboard from 'pages/warehouse_raw/Dashboard';
import WarehouseWarehouse from 'pages/warehouse_raw/Warehouse';
import WarehouseMyRequests from 'pages/warehouse_raw/MyRequests';

import ProductionDashboard from 'pages/production/Dashboard';
import ProductionProduction from 'pages/production/Production';
import ProductionRecipes from 'pages/production/Recipes';

import WarehouseFinishedDashboard from 'pages/warehouse_finished/Dashboard';
import WarehouseFinishedWarehouseFg from 'pages/warehouse_finished/WarehouseFg';
import WarehouseFinishedOrders from 'pages/warehouse_finished/Orders';


import SalesDashboard from 'pages/sales/Dashboard';
import SalesWarehouseFg from 'pages/sales/WarehouseFg';
import SalesOrders from 'pages/sales/Orders';

import TechnologistDashboard from 'pages/technologist/Dashboard';
import TechnologistProduction from 'pages/technologist/Production';
import TechnologistRecipes from 'pages/technologist/Recipes';
import TechnologistBoxes from 'pages/technologist/Boxes';

import Buyer from 'pages/buyer/Cabinet';

import ManagmentUsers from 'pages/managment/Users';
import ManagmentAnalytics from 'pages/managment/Analytics';

import Settings from 'pages/Settings';

export const APP_ROUTES = [
	{
		path: "/auth/login",
		component: <Login />,
		isPublic: true,
	},
	// Warehouse raw
	{
		path: "/warehouse-raw/dashboard",
		component: <WarehouseDashboard />,
		roles: ['WAREHOUSE_RAW'],
	},
	{
		path: "/warehouse-raw/warehouse",
		component: <WarehouseWarehouse />,
		// roles: ['WAREHOUSE_RAW', 'PROCUREMENT'],
	},
	{
		path: "/warehouse-raw/my-requests",
		component: <WarehouseMyRequests />,
		// roles: ['WAREHOUSE_RAW', 'PROCUREMENT'],
	},
	// Production
	{
		path: "/production/dashboard",
		component: <ProductionDashboard />,
		roles: ['PRODUCTION'],
	},
	{
		path: "/production/production",
		component: <ProductionProduction />,
		// roles: ['PRODUCTION'],
	},
	{
		path: "/production/recipes",
		component: <ProductionRecipes />,
		// roles: ['PRODUCTION'],
	},
	// Warehouse finished
	{
		path: "/warehouse-finished/dashboard",
		component: <WarehouseFinishedDashboard />,
		roles: ['WAREHOUSE_FINISHED'],
	},
	{
		path: "/warehouse-finished/warehouse-fg",
		component: <WarehouseFinishedWarehouseFg />,
		// roles: ['WAREHOUSE_FINISHED'],
	},
	{
		path: "/warehouse-finished/orders",
		component: <WarehouseFinishedOrders />,
		// roles: ['WAREHOUSE_FINISHED'],
	},
	// Technologist
	{
		path: "/technologist/dashboard",
		component: <TechnologistDashboard />,
		roles: ['TECHNOLOGIST'],
	},
	{
		path: "/technologist/production",
		component: <TechnologistProduction />,
		// roles: ['TECHNOLOGIST'],
	},
	{
		path: "/technologist/recipes",
		component: <TechnologistRecipes />,
		// roles: ['TECHNOLOGIST'],
	},
	{
		path: "/technologist/boxes",
		component: <TechnologistBoxes />,
		// roles: ['TECHNOLOGIST'],
	},
	// Sales
	{
		path: "/sales/dashboard",
		component: <SalesDashboard />,
		roles: ['SALES'],
	},
	{
		path: "/sales/warehouse-fg",
		component: <SalesWarehouseFg />,
		// roles: ['SALES'],
	},
	{
		path: "/sales/orders",
		component: <SalesOrders />,
		// roles: ['SALES'],
	},
	// Buyer
	{
		path: "/procurement/dashboard",
		component: <Buyer />,
		// roles: ['PROCUREMENT'],
	},
	// MANAGEMENT
	{
		path: "/managment/dashboard",
		component: <WarehouseDashboard />,
		roles: ['MANAGEMENT'],
	},
	{
		path: "/managment/analytics",
		component: <ManagmentAnalytics />,
		roles: ['MANAGEMENT'],
	},
	{
		path: "/managment/users",
		component: <ManagmentUsers />,
		// roles: ['MANAGEMENT'],
	},
	{
		path: "/settings",
		component: <Settings />,
	},
];